import React, {useEffect, useRef, useState, useContext} from "react";
import styles from "./createWorkspace/CreateWorkspace.module.scss"
import ModalBox from "../../Componnets/ModalBox/ModalBox";
import Button from "../../Componnets/Button/Button";
import {Scrollbars} from "react-custom-scrollbars";
import appContext from "../../../context/appContext";
import HeaderErrorBar from "../../Componnets/EsmManagement/headerErrorBar/HeaderErrorBar";
import {StageSpinner} from "react-spinners-kit";
import Toast from "../../Componnets/EsmManagement/toast/Toast";
import http from "../../../services/api/utilities/http";

const CreateWorkspace = ({ showModal, handleShowCreateWorkspaceModal, type, handleCallGetAnalysisApi, data={}, handleRetrySaveData, retrySaveWorkspace }) => {

    const [workspaceInfo, setWorkspaceInfo] = useState({name: null, description: null, dataConnectorInfo: {}});
    const [stepDetails, setStepDetails] = useState({});
    const [dataConnectorsData, setDataConnectorsData] = useState([]);
    const [responseStatus, setResponseStatus] = useState(null);
    const [errorInfo, setErrorInfo] = useState(null);
    const [dataConnectorApiResponse, setDataConnectorApiResponse] = useState(null);
    const [isRetryApiCall, setIsRetryApiCall] = useState(false);

    const context = useContext(appContext);

    const name = useRef();
    const description = useRef();

    useEffect(() => {
        if (type === 'edit') {
            setWorkspaceInfo({name: data.name, description: data.description, dataConnectorInfo: {id: data.data_pool}});
            setStepDetails({...stepDetails, title: "Edit Workspace"});
        }
    }, [type]);

    const handleGetDataConnectors = () => {
        setDataConnectorApiResponse('fetching');
        let token = localStorage.getItem('token')
        http.get('data_connector/data_pool_handler/',
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
            .then(res => {
                setDataConnectorApiResponse('success');
                setDataConnectorsData(res.data.data);
            })
            .catch(err => {
                setDataConnectorApiResponse('error');
                console.log(err.response);
            })
    }

    useEffect(() => {
        context.handleSaveWorkspaceStatus(responseStatus);
    }, [responseStatus])

    const workspaceData = context.handleWorkspace();

    const postData = (isRetry = false) => {
        setIsRetryApiCall(isRetry);

        let method = "post";
        let url = "data_connector/workspace/";
        if (type === "edit") {
            method = "patch";
            url = `data_connector/workspace/${data.id}/`
        }
        setResponseStatus('fetching');
        let token = localStorage.getItem('token');

        let newItemToAdd = {};
        let newData = [];
        const hasErrorWorkspaceData = workspaceData.find(item => item.status === "error");

        if (hasErrorWorkspaceData) {
            const newDataToSend = workspaceData.filter(item => item.status !== "error");
            newItemToAdd = {
                name: hasErrorWorkspaceData.name,
                description: hasErrorWorkspaceData.description,
                data_pool: hasErrorWorkspaceData.data_pool,
            }
            newData = [...newDataToSend, {
                ...newItemToAdd,
                status: 'loading'
            }];
        } else {
            newItemToAdd = {
                name: workspaceInfo.name,
                description: workspaceInfo.description,
                data_pool: workspaceInfo.dataConnectorInfo.id,
            }
            newData = [{
                ...newItemToAdd,
                status: 'loading'
            }, ...workspaceData];
        }
        context.handleWorkspace(newData);
        http[method](url, newItemToAdd)
            .then(res => {
                if (type === "addNew") {
                    const notIncludedStillLoadingData = newData.filter(item => {
                        if (!item.status || item.status !== 'loading') {
                            return item;
                        }
                    });
                    context.handleWorkspace([res.data.data, ...notIncludedStillLoadingData]);
                    context.handleSelectedWorkspaceInfo({id: res.data.data.id, name: res.data.data.name});
                    handleCallGetAnalysisApi(true);
                } else if (type === "edit") {
                    const editedWorkspaceData = context.handleWorkspace().map(item => {
                        if (item.id === data.id) {
                            return res.data.data;
                        }
                        return item;
                    })
                    context.handleWorkspace(editedWorkspaceData);
                }
                setResponseStatus('success');
            })
            .catch(err => {
                let newItemToAdd = {};
                const hasErrorWorkspaceData = workspaceData.find(item => item.status === "error");
                const notIncludedStillLoadingData = workspaceData.filter(item => {
                    if (!item.status || (item.status !== 'loading')) {
                        return item;
                    }
                });
                if (hasErrorWorkspaceData) {
                    const newDataToSend = workspaceData.filter(item => item.status !== "error");
                    newItemToAdd = {
                        name: hasErrorWorkspaceData.name,
                        description: hasErrorWorkspaceData.description,
                        data_pool: hasErrorWorkspaceData.data_pool,
                        status: 'error'
                    };
                    newData = [...newDataToSend, newItemToAdd];
                } else {
                    newItemToAdd = {
                        name: workspaceInfo.name,
                        description: workspaceInfo.description,
                        data_pool: workspaceInfo.dataConnectorInfo.id,
                        status: 'error'
                    };
                    newData = [...notIncludedStillLoadingData, newItemToAdd];
                }
                setWorkspaceInfo({
                    name: newItemToAdd.name,
                    description: newItemToAdd.description,
                    dataConnectorInfo: newItemToAdd.data_pool
                });
                context.handleWorkspace(newData);
                setResponseStatus("error");
                console.log(err.response);
            })
    }

    const handlePostWorkspaceData = () => {
        handleShowCreateWorkspaceModal();
        postData();
    }

    useEffect(() => {
        if (!showModal) {
            handleSetStep(1);
            if (name.current) {
                name.current.value = '';
            }
            if (description.current) {
                description.current.value = '';
            }
            setWorkspaceInfo({name: null, description: null, dataConnectorInfo: {}});
        }
    }, [showModal]);

    const handleSetStep = (step) => {
        switch (step) {
            case 1:
                setStepDetails({
                    step: 1,
                    title: type === "addNew" ? "New Workspace" : "Edit Workspace",
                    size: 'extraSmall'
                });
                break;
            case 2:
                if (workspaceInfo.name && workspaceInfo.name.replace(/\s/g, '').length >= 4) {
                    handleGetDataConnectors();
                    setStepDetails({
                        step: 2,
                        title: 'Select a Data Connector',
                        size: 'medium'
                    });
                } else {
                    setErrorInfo("At least 4 Characters");
                }
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (workspaceInfo.name && workspaceInfo.name.replace(/\s/g, '').length >= 4) {
            setErrorInfo(null);
        }
    }, [workspaceInfo.name]);

    useEffect(() => {
        handleSetStep(1);
    }, []);

    const handleSetDataConnectorItem = (id) => {
        const filteredData = dataConnectorsData.find(item => id === item.id);
        setWorkspaceInfo({...workspaceInfo, dataConnectorInfo: filteredData})
    }

    const handleSubmitCreateWorkspace = () => {
        handlePostWorkspaceData();
    }

    useEffect(() => {
        if (retrySaveWorkspace) {
            postData(true);
        }
        handleRetrySaveData(false);
    }, [retrySaveWorkspace]);

    return (
        <div className={styles.CreateWorkspace}>
            <ModalBox
                title={stepDetails.title}
                size={stepDetails.size}
                showModal={showModal}
                handleTriggerShowModal={handleShowCreateWorkspaceModal}
                handleOnPrevious={() => stepDetails !== 1 ? handleSetStep(stepDetails.step - 1) : null}
            >
                {
                    stepDetails.step === 1 && (
                        <div className={`${styles.nameInput} container-fluid p-0`}>
                            <div className={'row'}>
                                <div className={'col-sm-12'}>
                                    <label>Workspace Name</label>
                                </div>
                                <div className={'col-sm-12'}>
                                    <input ref={name} value={workspaceInfo.name} onChange={(e) => setWorkspaceInfo({...workspaceInfo, name: e.target.value})} type={'text'} placeholder={'Select a name for your workspace'} />
                                </div>
                                <div className={styles.warn}>{ errorInfo }</div>
                                <div className={'col-sm-12 mt-3'}>
                                    <label>Description</label>
                                    <textarea value={workspaceInfo.description} ref={description} onChange={(e) => setWorkspaceInfo({...workspaceInfo, description: e.target.value})} placeholder={'(Optional)'}></textarea>
                                </div>
                                <div style={{width: "100%"}} className={'d-flex justify-content-center'}>
                                    <div className={'col-sm-9 mt-5 align-items-center'}>
                                        <Button block type={'primary'} title={type === "addNew" ? 'Continue' : 'Submit'} onClick={() => type === "addNew" ? handleSetStep(2) : handleSubmitCreateWorkspace()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    stepDetails.step === 2 && (
                        <div className={styles.dataConnector}>
                            <p>
                                To create a workspace you need to select/create a data connector
                            </p>
                            <div style={{height: "400px"}}>
                                {
                                    dataConnectorApiResponse === 'success' && <div className={`container-fluid pl-0 pr-0 ${styles.connectorItemsWrapper}`}>
                                        <div className={`mt-4 ${styles.h100}`}>
                                            <Scrollbars
                                                renderView={({ style, ...props }) =>
                                                    <div {...props} style={{ ...style, width: "100%", height: "100%", overflowX: 'hidden', paddingLeft: 0 }}/>}
                                                renderTrackVertical={({ style, ...props }) =>
                                                    <div {...props} style={{ ...style, backgroundColor: '#C2C7ED', width: 1, borderRadius: 4, height: "100%", right: 5, paddingBottom: 1 }}/>
                                                }
                                                renderThumbVertical={({ style, ...props }) =>
                                                    <div {...props} style={{ ...style, backgroundColor: '#70789E', width: 4, borderRadius: 4, cursor: "pointer", left: -1}}/>
                                                }
                                            >
                                                {
                                                    dataConnectorsData.map(item => (
                                                        <div key={ item.id } className={`${styles.connectorItemWrapper} col-md-4`}>
                                                            <div
                                                                onClick={() => handleSetDataConnectorItem(item.id)}
                                                                className={
                                                                    [
                                                                        styles.connectorItem,
                                                                        (item.load_data_status == "Finished" && styles.loaded),
                                                                        (item.load_data_status == "NOT STARTED" && styles.notLoaded),
                                                                        (item.load_data_status == "HAS EXCEPTION" && styles.error),
                                                                        (item.load_data_status == "In progress" && styles.notLoaded),
                                                                        (workspaceInfo.dataConnectorInfo.id === item.id ? styles.selected : '')
                                                                    ].join(' ')
                                                                }
                                                            >
                                                                <div className={styles.name}>
                                                                    { item.name }
                                                                </div>
                                                                <div className={styles.status}>
                                                                    <span>Status: </span>
                                                                    <span>
                                                                    { item.load_data_status == "Finished" && <span>Loaded</span> }
                                                                        { item.load_data_status == "NOT STARTED" && <span>Verified (Not Loaded)</span> }
                                                                        { item.load_data_status == "HAS EXCEPTION" && <span>Error (Has Exception)</span> }
                                                                        { item.load_data_status == "In progress" && <span>In Progress</span> }
                                                                </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </Scrollbars>
                                        </div>
                                    </div>
                                }
                                {
                                    dataConnectorApiResponse === 'error' && (
                                        <div className={'mt-3'}>
                                            <HeaderErrorBar showError>
                                                <div>
                                                    DC List couldn't be retrieved. Please check your internet connection and try again.
                                                </div>
                                            </HeaderErrorBar>
                                            <div className={'mt-3'}>
                                                <Button
                                                    title={'Refresh List'}
                                                    type={'outline-secondary'}
                                                    onClick={handleGetDataConnectors}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    dataConnectorApiResponse === 'fetching' && (
                                        <div className={`${styles.spinner} col-sm-12 d-flex align-items-center justify-content-center p-0`}>
                                            <StageSpinner loading={true} color={"#0A195C"} size={55} />
                                        </div>
                                    )
                                }
                            </div>
                            <div className={'d-flex justify-content-end mt-4'}>
                                <div className={'ml-3'}>
                                    <Button disabled={responseStatus === 'fetching' || dataConnectorApiResponse !== 'success'} onClick={handleSubmitCreateWorkspace} title={responseStatus !== 'fetcing' ? (type === "addNew" ? 'Create My Workspace' : 'Edit My Workspace') : 'Please Wait...'} type={'primary'} />
                                </div>
                            </div>
                        </div>
                    )
                }
            </ModalBox>
            <Toast title={"Couldn't Create Workspace"} errorCode={"404"} show={responseStatus === "error" && !isRetryApiCall}>
                We couldn't connect to server. Check your internet connection or try again later.
            </Toast>
        </div>
    )
}

export default CreateWorkspace;